<template>
  <div id="app-rerouted">
    <ContentfulBanner v-if="shouldShowBanner" :segment-event-name="'UpgradePricing_PostLogin_Banner'" />
    <router-view />
    <PoppinsCondensedFooter v-if="routerReady" />
  </div>
</template>

<script>
import PoppinsCondensedFooter from '@/components/condensed_footer/PoppinsCondensedFooter.vue';
import ContentfulBanner from '@/components/contentful_banner/ContentfulBanner.vue';
import shouldShowContentfulBanner from '@/helpers/bannerDisplayLogic';

export default {
  name: 'App',
  components: {
    PoppinsCondensedFooter,
    ContentfulBanner,
  },
  data() {
    return {
      routerReady: false,
    };
  },
  computed: {
    shouldShowBanner() {
      return shouldShowContentfulBanner(this.$store.getters['account/getAccount'], this.$route.path);
    },
  },
  mounted() {
    // Prevents footer from loading before content loads
    this.$router.onReady(() => {
      this.routerReady = true;
    });
  },
};
</script>

<style lang="scss" scoped>
#app-rerouted {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 100px);
}

#app-rerouted:not(:has(> #contentful-banner)) > :first-child {
  flex: 1;
}

#app-rerouted:has(> #contentful-banner) > :nth-child(2) {
  flex: 1;
}
</style>
